<p8-layout-settings-page>
  <mat-card>
    <mat-card-title>
      <p8-layout-settings-header *ngIf="deposit"
                                 [titlePath]="['Consultation d\'un versement']"
                                 [iconRacine]="'source'"></p8-layout-settings-header>
    </mat-card-title>
    <mat-card-content fxLayout="column">
      <mat-progress-bar *ngIf="loading" [mode]="'indeterminate'"></mat-progress-bar>
      <!-- https://stackoverflow.com/a/65182096 -->
      <mat-tab-group mat-stretch-tabs="false" mat-align-tabs="start"
                     [(selectedIndex)]="selectedTabIndex" dynamicHeight>
        <mat-tab label="Versement">
          <mat-accordion multi *ngIf="deposit">
            <mat-expansion-panel class="elt__expansion-panel"
                                 expanded="true"
                                 *ngIf="deposit?.state && deposit?.state !== depositState.DRAFT">
              <mat-expansion-panel-header class="elt__expansion-panel-header">
                <mat-panel-title class="elt__panel-title">Prise en charge</mat-panel-title>
              </mat-expansion-panel-header>
              <app-take-charge [deposit]="deposit" [editMode]="canEdit()"></app-take-charge>
            </mat-expansion-panel>
            <mat-expansion-panel class="elt__expansion-panel">
              <mat-expansion-panel-header class="elt__expansion-panel-header">
                <mat-panel-title class="elt__panel-title">
                  Informations
                </mat-panel-title>
                <mat-panel-description class="elt__panel-description">
                  {{deposit?.deposit_identifier}} {{locationSvc.displayLocation(deposit?.location_obj)}}
                </mat-panel-description>
              </mat-expansion-panel-header>

              <mat-card>
                <mat-card-content>
                  <div fxLayout="column">
                    <mat-list role="list" fxLayout="row" fxFlex>
                      <mat-list-item role="listitem">
                        <div fxLayout="column">
                          <span class="lbl">Intitulé du service versant</span>
                          <span class="ctt">{{deposit?.dir_cmp_obj?.entite_archivage_obj?.entite_obj?.name}}</span>
                        </div>
                      </mat-list-item>
                      <mat-list-item role="listitem">
                        <div fxLayout="column">
                          <span class="lbl">Service / Pôle / Département / Labo</span>
                          <span class="ctt">{{getSvcDepLabo()}}</span>
                        </div>
                      </mat-list-item>
                    </mat-list>

                    <mat-list role="list" fxLayout="row" fxFlex>
                      <mat-list-item role="listitem">
                        <div fxLayout="column">
                          <span class="lbl">Responsable du versement</span>
                          <span class="ctt">{{userInfo()}}</span>
                        </div>
                      </mat-list-item>
                      <mat-list-item role="listitem">
                        <div fxLayout="column">
                          <span class="lbl">Courriel</span>
                          <span class="ctt">{{deposit?.user_obj?.email_pro}}</span>
                        </div>
                      </mat-list-item>
                      <mat-list-item role="listitem">
                        <div fxLayout="column">
                          <span class="lbl">Bureau</span>
                          <span class="ctt">{{deposit?.office}}</span>
                        </div>
                      </mat-list-item>
                      <mat-list-item role="listitem">
                        <div fxLayout="column">
                          <span class="lbl">Téléphone</span>
                          <span class="ctt">{{deposit?.phone_number}}</span>
                        </div>
                      </mat-list-item>
                    </mat-list>

                    <mat-list role="list" fxLayout="row" fxFlex>
                      <mat-list-item role="listitem">
                        <div fxLayout="column">
                          <span class="lbl">Métrage</span>
                          <span class="ctt">{{linearSize()}}</span>
                        </div>
                      </mat-list-item>
                      <mat-list-item role="listitem">
                        <div fxLayout="column">
                          <span class="lbl">Nombre total de boites</span>
                          <span class="ctt">{{deposit?.boxs_obj?.length?.toString()}}</span>
                        </div>
                      </mat-list-item>
                      <mat-list-item role="listitem">
                        <div fxLayout="column">
                          <span class="lbl">Nombre total de documents</span>
                          <span class="ctt">{{deposit?.article_number?.toString()}}</span>
                        </div>
                      </mat-list-item>
                    </mat-list>

                    <mat-list role="list" fxLayout="row" fxFlex>
                      <mat-list-item role="listitem">
                        <div fxLayout="column">
                          <span class="lbl">Année de révision min</span>
                          <span class="ctt">{{deposit?.revision_year_min?.toString()}}</span>
                        </div>
                      </mat-list-item>
                      <mat-list-item role="listitem">
                        <div fxLayout="column">
                          <span class="lbl">Année de révision max</span>
                          <span class="ctt">{{deposit?.revision_year_max?.toString()}}</span>
                        </div>
                      </mat-list-item>
                      <mat-list-item role="listitem">
                        <div fxLayout="column">
                          <span class="lbl">Sort final</span>
                          <span class="ctt">{{depositSvc.displayConservation(deposit)}}</span>
                        </div>
                      </mat-list-item>
                    </mat-list>
                  </div>
                </mat-card-content>
              </mat-card>

            </mat-expansion-panel>

            <app-boite *ngFor="let box of deposit?.boxs_obj" [box]="box"></app-boite>
          </mat-accordion>
        </mat-tab>

        <mat-tab label="Dialogues" *ngIf="deposit && deposit?.state !== depositState.DRAFT">
          <p8-list-comments *ngIf="deposit?.id"
                            [object_id]="deposit?.id"
                            [content_type]="deposit?.content_type"
                            [canSeePrivate]="false"></p8-list-comments>

          <p8-comment *ngIf="deposit?.id" [object_id]="deposit?.id" [content_type]="deposit?.content_type"
                      [application]="application"
                      [hasPrivate]="false" [hasFilesToUpload]="true" [maxFiles]="1"
                      [sendMail]="true" [sendTosPublic]="emails"
                      [linkToOpenOrTitle]="this"></p8-comment>
        </mat-tab>

      </mat-tab-group>
    </mat-card-content>
  </mat-card>
  <p8-layout-settings-footer [flexLayoutAlign]="'end'">
    <button mat-raised-button type="button" (click)="goBack()" matTooltip="Retour">
      Retour à votre liste
    </button>
  </p8-layout-settings-footer>
</p8-layout-settings-page>
